'use strict';

import State, { IPurchasesDictionaries } from './state';
import StandardDictionaryItem from '@core/js/ddriven/domain/model/common/dictionaries/StandardDictionaryItem.valueobject';
import ExtendedDictionaryItem from '@core/js/ddriven/domain/model/common/dictionaries/ExtendedDictionaryItem.valueobject';

const getters = {
    types: function (state: State): StandardDictionaryItem[] | null {
        return state.types;
    },
    statuses: function (state: State): StandardDictionaryItem[] | null {
        return state.statuses;
    },
    all: function (state: State): Record<string, StandardDictionaryItem[] | ExtendedDictionaryItem[] | null> {
        return {
            types: state.types,
            statuses: state.statuses
        };
    }
};

export default getters;
